<div class="modal">
    <header class="header">
        <div class="close-button" *ngIf="isError" (click)="closeModal()">
            <i class="ju ju-close"></i>
        </div>
        <span *ngIf="isError" class="title">Warnung</span>
        <span *ngIf="!isError" class="title">Gerät angelegt</span>
    </header>
    <div *ngIf="isError" class="modal-content">
        Beim Senden der Daten ist ein Fehler aufgetreten. Speichern Sie die
        Installationsdatei und senden Sie diese an
        <a href="mailto:immosup@juconn.atlassian.net">immosup@juconn.atlassian.net</a>
        <div class="error-header">
            <div>Fehler:</div>
            <button type="button" class="secondary copy-button" (click)="onCopyErrorTextToClipClick()">
                <i class="ju ju-copy"></i>
                Fehler kopieren:
            </button>
        </div>


        <div class="error-text">{{ errorText }}</div>
    </div>
    <div *ngIf="!isError" class="modal-content">
        <div class="modal-success">{{ successIcon }}</div>
        Das Gerät wurde erfolgreich angelegt. Sie können die Seite neu laden, um ein weiteres Gerät anzulegen.
    </div>
    <div class="popup-footer">
        <button *ngIf="isError" class="primary" (click)="onRepeatButtonClick()">
            Popup, schließen
        </button>
        <button
                *ngIf="isError"
                class="secondary"
                (click)="onDownloadButtonClick()">
            Datei speichern und schließen
        </button>
        <button
                *ngIf="!isError"
                class="primary"
                (click)="onCompleteButtonClick()">
            Neu laden
        </button>
    </div>
</div>
